/**
 * The order after moving one entry a step up (`-1`) or down (`1`). Returns
 * the input unchanged when the move would leave the list.
 */
export const moveUuid = (
  uuids: readonly string[],
  uuid: string,
  step: -1 | 1,
): string[] => {
  const from = uuids.indexOf(uuid);
  const to = from + step;
  if (from === -1 || to < 0 || to >= uuids.length) {
    return [...uuids];
  }
  const next = [...uuids];
  next.splice(from, 1);
  next.splice(to, 0, uuid);
  return next;
};
